import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const saveOnboardingData = (req: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.saveOnboardingData),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: req,
  }

  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { saveOnboardingData }
